import React, { FC } from 'react'
import { Grid, Stack } from '@mui/material'
import { AxiosError } from 'axios'

import { FileControl, SubmitButton, SubmitErrorMessage } from '@/components/form'
import { Infomer } from '@/components/infomer.tsx'
import { RadioGroup } from '@/components/radio-group.tsx'
import { B2CRegistryInitErrorResponse } from '@/@types/b2c.types.ts'

type DialogFileUploadProps = {
  onLoadTemplate?: (choose: string) => void
  onChangeTemplate?: (event: React.ChangeEvent<HTMLInputElement>) => void
  templateValue?: string
  isError: boolean
  error: AxiosError<B2CRegistryInitErrorResponse> | null
  formName?: string
}

export const B2CRegistryDialogFileUpload: FC<DialogFileUploadProps> = ({
  onLoadTemplate,
  onChangeTemplate,
  templateValue,
  isError,
  error,
  formName,
}) => {
  return (
    <Stack gap={3}>
      <Stack gap={2} direction="column">
        <FileControl name="file" placeholder="Файл реестра" accept=".xlsx,.csv" />
        <Infomer
          type={'warning'}
          title={'Внимание!'}
          description={'Максимальное количество полей в файле импорта должно составлять не более 50'}
        />
        <RadioGroup
          onLoad={onLoadTemplate}
          onChange={onChangeTemplate}
          row
          value={templateValue}
          label="Скачать шаблон реестра"
          items={[
            { title: '.xlsx', value: 'xlsx' },
            { title: '.csv', value: 'csv' },
          ]}
        />
      </Stack>
      <Grid direction="column" spacing={1} container>
        <Grid>
          <SubmitErrorMessage
            message={isError ? error?.response?.data?.message : 'Произошла непредвиденная ошибка, попробуйте ещё раз'}
            isError={isError}
          />
        </Grid>
        <Grid>
          <SubmitButton form={formName}>Подтвердить</SubmitButton>
        </Grid>
      </Grid>
    </Stack>
  )
}
